import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import ModalManager from "../../shared/modal";
import Loading from "../../shared/loading";
import TextUtilities from "../../shared/utilities/text_utilities";
import sanitizeHtml from "sanitize-html";

let modalId, documentUnit, loading, continueCallback;

function loadDocumentUnit(unit) {
    loading = true;
    documentUnit = null;
    // Always fetched fresh so instruction edits made in admin show up immediately.
    Requester.get(Gateway.public + "units/document/" + unit.id + "/?enrolmentId=" + unit.enrolment.id)
        .then(function (result) {
            documentUnit = result;
        })
        .catch(function (error) {
            const code = error?.response?.properties?.errorCode || "UnexpectedError";
            Toasts.add("error", i18n.t("error"), i18n.t(code));
        })
        .then(function () {
            loading = false;
        });
}

function continueToDocument() {
    ModalManager.close(modalId);
    if (continueCallback)
        continueCallback();
}

const Modal_Document_Instructions = {
    oninit: function (vnode) {
        continueCallback = vnode.attrs.callback;
        loadDocumentUnit(vnode.attrs.unit);
    },
    view: function () {
        const instructions = documentUnit?.unit?.instructions;

        return loading ? m(Loading) : [
            TextUtilities.hasVisibleText(instructions) ? m(".instructions.richtext.mb-2",
                m.trust(sanitizeHtml(instructions, {allowedTags: sanitizeHtml.defaults.allowedTags, allowedAttributes: {"*": ["style", "class"], "a": ["href", "target"]}}))
            ) : "",
            m("p.mb-2", i18n.t("select_continue_to_read_document")),
            m(".form-buttons", [
                m("button.btn-cta", {onclick: continueToDocument}, i18n.t("continue"))
            ])
        ];
    },
    setModalId: function (id) {
        modalId = id;
    }
};

export default Modal_Document_Instructions;
